export default __webpack_public_path__ + "images/9913d187aa656df90364e6daca2c1bff-updated_holiday_touchpoint_image.webp";